export default function SitemapCont ({ sectionTitle, sectionList }) {
  return (
    <div className='sitemap_module_w'>
      <div className='sitemap_module_title'>{sectionTitle}</div>
      <ul className='sitemap_module_list'>
        {sectionList.map((item, index) => {
          return (
            <li key={index} className='sitemap_module_inner'>
              <a href={item.link} className='sitemap_module_link'>{item.title}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
